<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import { mapGetters } from 'vuex'
import { Helper } from '@/mixin/helper'
import McBadge from '@/components/McBadge'

/**
 * Starter component
 */
export default {
  page: {
    title: 'Setting',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    McBadge,
  },
  mixins: [Helper],
  data() {
    return {
      phaseOneShow: false,
    }
  },

  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      hasAccessAll: 'identity/hasAccessAll',
      isWhitelabel: 'identity/isWhitelabel',
      isParent: 'identity/isParent',
      isNewModule: 'identity/isNewModule',
      getFeatureFlagData: 'identity/getFeatureFlagData',
    }),
    title() {
      return this.$t('setting.homePage.pengaturan')
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />

    <div class="card mc-card mc-card-front">
      <div class="card-body">
        <b-tabs content-class="p-3 text-muted">
          <b-tab active class="border-0">
            <template v-slot:title>
              <span class="d-none d-sm-inline-block">
                {{ $t('setting.homePage.pengaturan') }}
              </span>
            </template>
            <b-row class="mc-card__list">
              <!-- Setting Product -->
              <b-col
                sm="12"
                md="6"
                v-if="hasAccessAll(['tms:create', 'tms:read', 'tms:update', 'tms:delete'])"
              >
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Setting Product' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_cube"></i>
                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('setting.homePage.product') }}</h4>
                    <p>{{ $t('setting.homePage.textProduct') }}</p>
                  </div>
                </b-button>
              </b-col>

              <!-- Setting Delivery -->
              <b-col
                sm="12"
                md="6"
                v-if="hasAccessAll(['tms:create', 'tms:read', 'tms:update', 'tms:delete'])"
              >
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Setting Delivery' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_pending-action"></i>
                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('setting.homePage.delivery') }}</h4>
                    <p>{{ $t('setting.homePage.textDelivery') }}</p>
                  </div>
                </b-button>
              </b-col>

              <!-- Setting Fleet Task -->
              <b-col
                sm="12"
                md="6"
                v-if="hasAccessAll(['tms:create', 'tms:read', 'tms:update', 'tms:delete'])"
              >
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Setting Fleet Task' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_truck-moving"></i>
                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('setting.homePage.fleetTask') }}</h4>
                    <p>{{ $t('setting.homePage.textFleetTask') }}</p>
                  </div>
                </b-button>
              </b-col>

              <!-- Setting Additional Cost -->
              <b-col
                sm="12"
                md="6"
                v-if="
                  hasAccessAll(['vms:create', 'vms:read', 'vms:update', 'vms:delete']) &&
                  $store.state.config.contractVendorAdditionalCostFlag
                "
              >
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Setting Additional Cost' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_folder"></i>
                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('setting.homePage.additionalCost') }}</h4>
                    <p>{{ $t('setting.homePage.textAdditionalCost') }}</p>
                  </div>
                </b-button>
              </b-col>

              <b-col
                sm="12"
                md="6"
                v-if="hasAccessAll(['ugroups:read', 'c1a-default-setpengguna:read'])"
              >
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'List User Setting' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_person"></i>
                  <McBadge
                    v-if="isNewModule('c1-set-pengguna')"
                    :text="$t('global.new')"
                    variant="danger"
                    size="medium"
                    type="pill"
                    class="text-uppercase float-end"
                  ></McBadge>
                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('setting.homePage.pengguna') }}</h4>
                    <p>{{ $t('setting.homePage.textPengguna') }}</p>
                  </div>
                </b-button>
              </b-col>

              <b-col
                sm="12"
                md="6"
                v-if="hasAccessAll(['employee_recruited_at:read', 'c2a-default-setkaryawan:read'])"
              >
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'List Employee Setting' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_people"></i>
                  <McBadge
                    v-if="isNewModule('c2-set-karyawan')"
                    :text="$t('global.new')"
                    variant="danger"
                    size="medium"
                    type="pill"
                    class="text-uppercase float-end"
                  ></McBadge>
                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('setting.homePage.karyawan') }}</h4>
                    <p>{{ $t('setting.homePage.textKaryawan') }}</p>
                  </div>
                </b-button>
              </b-col>
              <b-col
                sm="12"
                md="6"
                v-if="hasAccessAll(['vehicles:read', 'c3a-default-setkendaraan:read'])"
              >
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'List Fleet Setting' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_car"></i>
                  <McBadge
                    v-if="isNewModule('c3-set-kendaraan')"
                    :text="$t('global.new')"
                    variant="danger"
                    size="medium"
                    type="pill"
                    class="text-uppercase float-end"
                  ></McBadge>
                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('setting.homePage.kendaraan') }}</h4>
                    <p>{{ $t('setting.homePage.textKendaraan') }}</p>
                  </div>
                </b-button>
              </b-col>

              <b-col
                sm="12"
                md="6"
                v-if="
                  hasAccess([
                    'address_categories:read',
                    'company_categories:read',
                    'c4a-default-setumum:read',
                    'c4b-setumum-industrikategori:read',
                  ])
                "
              >
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'List General Setting' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_folder"></i>
                  <McBadge
                    v-if="isNewModule('c4-set-umum')"
                    :text="$t('global.new')"
                    variant="danger"
                    size="medium"
                    type="pill"
                    class="text-uppercase float-end"
                  ></McBadge>
                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('setting.homePage.umum') }}</h4>
                    <p>{{ $t('setting.homePage.textUmum') }}</p>
                  </div>
                </b-button>
              </b-col>
              <b-col sm="12" md="6" v-if="hasAccess(['c8a-default-set-profil-perusahaan:read'])">
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'List Company Profile Setting' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_people"></i>
                  <McBadge
                    v-if="
                      isNewModule('c8-set-profilperusahaan')
                    "
                    :text="$t('global.new')"
                    variant="danger"
                    size="medium"
                    type="pill"
                    class="text-uppercase float-end"
                  ></McBadge>
                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('setting.homePage.profilPerusahaan') }}</h4>
                    <p>{{ $t('setting.homePage.textProfilPerusahaan') }}</p>
                  </div>
                </b-button>
              </b-col>
              <b-col
                sm="12"
                md="6"
                v-if="hasAccessAll(['vgroups:read', 'c5a-default-setgrupkendaraan:read'])"
              >
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'List Fleet Group Setting' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_car-group"></i>
                  <McBadge
                    v-if="
                      isNewModule('c5-set-grupkendaraan')
                    "
                    :text="$t('global.new')"
                    variant="danger"
                    size="medium"
                    type="pill"
                    class="text-uppercase float-end"
                  ></McBadge>

                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('setting.homePage.grupKendaraan') }}</h4>
                    <p>{{ $t('setting.homePage.textGrupKendaraan') }}</p>
                  </div>
                </b-button>
              </b-col>
              <b-col sm="12" md="6" v-if="phaseOneShow">
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'List Maintenance Setting' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_truck-maintenance"></i>
                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('setting.homePage.servis') }}</h4>
                    <p>{{ $t('setting.homePage.textServis') }}</p>
                  </div>
                </b-button>
              </b-col>
              <b-col
                sm="12"
                md="6"
                v-if="hasAccess(['vehicle_odometer:read', 'vehicle_odometer:update'])"
              >
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'List Odometer Setting' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_odometer"></i>
                  <McBadge
                    v-if="isNewModule('c6-set-odometer')"
                    :text="$t('global.new')"
                    variant="danger"
                    size="medium"
                    type="pill"
                    class="text-uppercase float-end"
                  ></McBadge>
                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('setting.homePage.odometer') }}</h4>
                    <p>{{ $t('setting.homePage.textOdometer') }}</p>
                  </div>
                </b-button>
              </b-col>
              <b-col sm="12" md="6" v-if="$store.state.config.mode == 'development'">
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Setting Live View' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_live-view"> </i>

                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('setting.homePage.liveView') }}</h4>
                    <p>{{ $t('setting.homePage.textLiveView') }}</p>
                  </div>
                </b-button>
              </b-col>
              <b-col
                sm="12"
                md="6"
                v-if="
                  hasAccess([
                    'maintenance:read',
                    'maintenance:update',
                    'maintenance:create',
                    'maintenance:delete',
                  ])
                "
              >
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'List Maintenance Setting' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_settings"> </i
                  ><McBadge
                    v-if="
                      isNewModule('c10-set-pemeliharaan')
                    "
                    :text="$t('global.new')"
                    variant="danger"
                    size="medium"
                    type="pill"
                    class="text-uppercase float-end"
                  ></McBadge>
                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('setting.homePage.pemeliharaanKendaraan') }}</h4>
                    <p>{{ $t('setting.homePage.textPemeliharaanKendaraan') }}</p>
                  </div>
                </b-button>
              </b-col>
              <b-col
                sm="12"
                md="6"
                v-if="
                  getAccessRight() &&
                  hasAccess('c7a-default-setpengembang:read', 'generate_public_api_key:create')
                "
              >
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Setting Token API' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_code"></i>
                  <McBadge
                    v-if="isNewModule('c7-set-pengembang')"
                    :text="$t('global.new')"
                    variant="danger"
                    size="medium"
                    type="pill"
                    class="text-uppercase float-end"
                  ></McBadge>
                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('setting.homePage.tokenApi') }}</h4>
                    <p>{{ $t('setting.homePage.textTokenApi') }}</p>
                  </div>
                </b-button>
              </b-col>
              <b-col sm="12" md="6" v-if="this.getFeatureFlag('vsms2_management_token').value">
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Setting Token' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_cloud-upload"></i>

                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('setting.homePage.manajemenToken') }}</h4>
                    <p>{{ $t('setting.homePage.textManajemenToken') }}</p>
                  </div>
                </b-button>
              </b-col>
              <b-col
                sm="12"
                md="6"
                v-if="
                  getAccessRight() &&
                  hasAccess([
                    'c13a-default-logo:read',
                    'c13b-default-color:read',
                    'c13c-default-banner:read',
                    'c13d-default-contact:read',
                  ]) &&
                  isWhitelabel() &&
                  isParent()
                "
              >
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Management Whitelabel' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_brush"></i>

                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('setting.homePage.whitelabel') }}</h4>
                    <p>{{ $t('setting.homePage.textWhitelabel') }}</p>
                  </div>
                </b-button>
              </b-col>
              <b-col
                sm="12"
                md="6"
                v-if="getAccessRight() && hasAccess(['c11a-default-gps:read', 'c11b-default-subdomain:read']) && isParent()"
              >
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Management Asset' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_sensor-rfid"></i>

                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('setting.homePage.asset') }}</h4>
                    <p>{{ $t('setting.homePage.textAsset') }}</p>
                  </div>
                </b-button>
              </b-col>
              <b-col sm="12" md="6" v-if="hasAccess(['set_idle_parking:read', 'set_fuel:read'])">
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Setting Tracker & Sensor' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_radio"></i>

                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('setting.homePage.trackerAndSensor') }}</h4>
                    <p>{{ $t('setting.homePage.textTrackerAndSensor') }}</p>
                  </div>
                </b-button>
              </b-col>
              <b-col
                sm="12"
                md="6"
                v-if="
                  hasAccess([
                    'financial-record:create',
                    'financial-record:read',
                    'financial-record:update',
                    'financial-record:delete',
                  ])
                "
              >
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Setting Cost Category' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_rupiah"></i>

                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('setting.homePage.costCategory') }}</h4>
                    <p>{{ $t('setting.homePage.textCostCategory') }}</p>
                  </div>
                </b-button>
              </b-col>
              <b-col sm="12" md="6">
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Sub Setting' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_file-text"></i>

                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('setting.homePage.template') }}</h4>
                    <p>{{ $t('setting.homePage.textTemplate') }}</p>
                  </div>
                </b-button>
              </b-col>
              <b-col
                sm="12"
                md="6"
                v-if="
                  this.hasAccessAll([
                    'tms-integration-accurate:delete',
                    'tms-integration-accurate:update',
                    'tms-integration-accurate:read',
                    'tms-integration-accurate:create',
                  ])
                "
              >
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Integration' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_Sync"></i>

                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('setting.homePage.integration') }}</h4>
                    <p>{{ $t('setting.homePage.textIntegration') }}</p>
                  </div>
                </b-button>
              </b-col>
              <b-col sm="12" md="6">
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Setting Custom Field' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_Sync"></i>

                  <div class="mc-card__list-item-content">
                    <h4>{{ 'Kolom Custom' }}</h4>
                    <p>{{ 'Mengelola tambahan kolom pada modul.' }}</p>
                  </div>
                </b-button>
              </b-col>
              <b-col sm="12" md="6" v-if="hasAccess(['webhook_api:read'])">
                <b-button
                  variant="outline-light"
                  @click="$router.push({ name: 'Setting Webhook' })"
                  class="d-block w-100 mc-card__list-item clearfix"
                >
                  <i class="mc-fa icon-outline_Sync"></i>

                  <div class="mc-card__list-item-content">
                    <h4>{{ $t('setting.homePage.webhook') }}</h4>
                    <p>{{ $t('setting.homePage.textWebhook') }}</p>
                  </div>
                </b-button>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </Layout>
</template>
